import ToolTip from "../Components/Tooltip";

interface ClickInquiriesProps {
    click:number
}

const ClickInquiries = ({click}:ClickInquiriesProps) => {
    
    const clickContent = `Totalt antall klikk på oppføring i valgt periode`;

    return (
        <div className='col-md-6 mb-4'>
            <div className="card">
                <div className="card-header">
                <div className="d-flex align-items-center">
                    <h2 className="p2">Klikk</h2>
                    <ToolTip title='Klikk' content={clickContent} id="clickpopover" />
                </div>
                </div>
                <div className="card-body">
                <p className="fs-1">{new Intl.NumberFormat('nb-NO').format(click)}</p>  
                </div>
            </div>
        </div>
    );
}

export default ClickInquiries;